import data from "./data";

/**
 * After-upload feedback on the share-link landing page.
 *
 * Auto-approved photos are in the gallery straight away, so the page reloads
 * to show them; otherwise it explains that they appear once approved.
 */
const NOTE_KEY = "fgfuu-landing-uploaded";

export default () => {
    const main = document.querySelector( ".fg-feu-landing-page .fg-feu-landing" );
    if ( !main ) return;

    const show = text => {
        let note = main.querySelector( ".fg-feu-landing-note" );
        if ( !note ) {
            note = document.createElement( "p" );
            note.className = "fg-feu-landing-note";
            note.setAttribute( "role", "status" );
            const form = main.querySelector( ".fg-feu-form" );
            if ( form ) form.before( note );
            else main.append( note );
        }
        note.textContent = text;
    };

    try {
        const saved = window.sessionStorage.getItem( NOTE_KEY );
        if ( saved ) {
            window.sessionStorage.removeItem( NOTE_KEY );
            show( saved );
        }
    } catch ( error ) {
        // Storage can be unavailable; the note is only a convenience.
    }

    document.addEventListener( "fgfuu:uploaded", event => {
        const showsGallery = !!main.querySelector( ".fg-feu-landing-gallery" );
        if ( event.detail?.result?.auto_approved ) {
            if ( showsGallery ) {
                try {
                    window.sessionStorage.setItem( NOTE_KEY, data.i18n.landingAdded );
                } catch ( error ) {
                    // Reload anyway; the new photos are the confirmation.
                }
                window.location.reload();
                return;
            }
            show( data.i18n.landingAdded );
            return;
        }
        show( showsGallery ? data.i18n.landingPendingBelow : data.i18n.landingPending );
    } );
};
